import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import useIsBrowser from 'hooks/useIsBrowser';
// TODO: Replace this with a better way to import without default
// eslint-disable-next-line import/no-named-default
import { default as isOnPDP } from 'commons/isPDP';

// React Suspense and Next.js segment-cache transitions can briefly hide the
// PDP element via `display: none` while a route segment is streaming in.
// Wait this long before treating an invisible PDP element as "no longer on a
// PDP" so the header doesn't flicker during those transient hides. Long
// enough to absorb hydration / streaming pauses, short enough to feel
// instant on real navigation.
const HIDE_GRACE_MS = 750;
const useIsPDP = () => {
  const $ = _c(3);
  const isBrowser = useIsBrowser();
  const [isPDP, setIsPDP] = useState(false);
  let t0;
  let t1;
  if ($[0] !== isBrowser) {
    t0 = () => {
      if (!isBrowser) {
        return;
      }
      let pendingHideTimer;
      const cancelPendingHide = () => {
        if (pendingHideTimer) {
          clearTimeout(pendingHideTimer);
          pendingHideTimer = undefined;
        }
      };
      const checkIfPDP = () => {
        if (isOnPDP()) {
          cancelPendingHide();
          setIsPDP(true);
        } else {
          if (!pendingHideTimer) {
            pendingHideTimer = setTimeout(() => {
              pendingHideTimer = undefined;
              if (!isOnPDP()) {
                setIsPDP(false);
              }
            }, HIDE_GRACE_MS);
          }
        }
      };
      checkIfPDP();
      const observer = new MutationObserver(checkIfPDP);
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["style"]
      });
      return () => {
        cancelPendingHide();
        observer.disconnect();
      };
    };
    t1 = [isBrowser];
    $[0] = isBrowser;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return isPDP;
};
export default useIsPDP;